export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
} as const

const apiConstants = {
  BASE_RPC_PATH: '/rpc',
  TENANT_RPC_PATH: '/rpc/tenants',
  USER_RPC_PATH: '/rpc/users',
  USER_CAMPAIGNS_RPC_PATH: '/rpc/users/campaigns',
  USER_OFFERS_RPC_PATH: '/rpc/users/redemptions',
  USER_TRANSACTIONS_RPC_PATH: '/rpc/users/wallet',
  USER_PROVIDERS_RPC_PATH: '/rpc/users/providers',
  CAMPAIGNS_RPC_PATH: '/rpc/campaigns',
  CAMPAIGN_CATEGORIES_RPC_PATH: '/rpc/campaign-categories',
  INVOICES_RPC_PATH: '/rpc/invoices',
  COUPONS_RPC_PATH: '/rpc/coupons',
  OFFERS_RPC_PATH: '/rpc/offers',
  TARGET_GROUP_RPC_PATH: '/rpc/target-groups',
  OFFER_CATEGORIES_RPC_PATH: '/rpc/offer-categories',
  OFFER_CATALOGS_RPC_PATH: '/rpc/offer-catalogs',
  FEATURE_FLAGS_RPC_PATH: '/rpc/feature-flags',
  ADMIN_USERS_RPC_PATH: '/rpc/admin-users',
  ANNOUNCEMENTS_RPC_PATH: '/rpc/new-feature-dialogs',
  POINTS_DISTRIBUTION_RPC_PATH: '/rpc/points-distribution',
  ACHIEVEMENTS_RPC_PATH: '/rpc/achievements',
  BEHAVIORS_RPC_PATH: '/rpc/behaviors',
  UPDATES_RPC_PATH: '/rpc/update-cards',
  PROVIDERS_RPC_PATH: '/rpc/providers',
  IMAGES_RPC_PATH: '/rpc/images',
  DEVICES_RPC_PATH: '/rpc/devices',
  TRANSLATIONS_RPC_PATH: '/rpc/translations',
  ACTION_BOXES_RPC_PATH: '/rpc/action-boxes',
  TRANSIT_VALIDATION_RPC_PATH: '/rpc/transit-validation',
  NOTIFICATIONS_RPC_PATH: '/rpc/notifications',
  REST_NOTIFICATIONS_PATH: '/api/admin/notifications',
  // TODO: Remove Above Endpoints when Migration to backend 2.0 is finished.
  BASE_REST_PATH: '/admin',
  AUTH_LOGIN_URL: '/admin/auth/login',
  AUTH_FORGOT_PASSWORD_URL: '/admin/auth/forgot-password',
  AUTH_LOGOUT_URL: '/admin/auth/logout',
  AUTH_SETUP_MFA_SET_URL: '/admin/auth/setup/mfa',
  AUTH_VERIFY_MFA_URL: '/admin/auth/verify/mfa',
  ACTION_BOXES_REST_URL: '/admin/action-boxes',
  ACTION_BOXES_CATEGORIES_REST_URL: '/admin/action-boxes/categories',
  ADMIN_USERS_REST_URL: '/admin/users',
  TENANTS_REST_URL: '/admin/tenants'
}

export default apiConstants
